import React, { useEffect, useRef } from 'react';
import "./styles.less";

export const Carousel = ({ data, ItemComponent, onEndReached = () => { }, onVisibleIdChange = (lat, lng, id, index) => { } }) => {
    const carouselRef = useRef(null);
    const tolerance = 20;

    const handleScroll = () => {
        const carousel = carouselRef.current;

        if (carousel.scrollLeft + carousel.offsetWidth >= carousel.scrollWidth - tolerance) {
            onEndReached();
        }

        const cards = carousel.querySelectorAll(".card");
        let closestCard = null;
        let minDistance = Infinity;

        cards.forEach(card => {
            const cardRect = card.getBoundingClientRect();
            const carouselRect = carousel.getBoundingClientRect();
            const cardCenter = cardRect.left + cardRect.width / 2;
            const carouselCenter = carouselRect.left + carouselRect.width / 2;
            const distance = Math.abs(carouselCenter - cardCenter);
            if (distance < minDistance) {
                minDistance = distance;
                closestCard = card;
            }
        });

        if (closestCard) {
            const lat = closestCard.dataset.lat;
            const lng = closestCard.dataset.lng;
            const id = closestCard.dataset.id;
            const parent = closestCard.dataset.parent;
            const index = closestCard.dataset.index;

            onVisibleIdChange(lat, lng, (parent ?? Number(id)), index);
        }
    };

    useEffect(() => {
        const carousel = carouselRef.current;
        carousel.addEventListener("scroll", handleScroll);

        return () => {
            carousel.removeEventListener("scroll", handleScroll);
        };
    }, [onEndReached, onVisibleIdChange]);

    return (
        <div className="wrapper">
            <ul className="carousel" ref={carouselRef}>
                {data.map((item, index) => (
                    <li className="card" key={index} data-id={item.id} data-parent={item.parent} data-lng={item.long} data-lat={item.lat} data-index={index}>
                        <ItemComponent data={item} />
                    </li>
                ))}
            </ul>
        </div>
    );
};
